module.exports = __webpack_public_path__ + "img/logo.bc5562f7.png";